import { useCurrentUser } from '@oppy/omniv2-core';
import { Heading1 } from '@oppy/omniv2-ui';
import { PERMISSIONS, RESOURCES, usePermissions } from '@oppy/omniv2-utils';
import { useNavigate, useParams } from 'react-router-dom';

export default function ForbiddenPage() {
  const navigate = useNavigate();
  const { entityId: entityIdFromParams } = useParams();
  const currentUser = useCurrentUser();
  const { hasPermission } = usePermissions(currentUser ?? undefined);

  const entityIdFromStorage = localStorage.getItem('entityId');
  const entityId = entityIdFromParams || entityIdFromStorage;

  const getSmartHomePage = (): string => {
    if (!currentUser) return '/';

    const baseUrl = entityId ? `/${entityId}` : '';

    const accessiblePages = [
      {
        resource: RESOURCES.RCS_SETTING,
        permission: PERMISSIONS.ACCESS,
        path: `${baseUrl}/rcs`,
      },
      {
        resource: RESOURCES.SALES_COMPLIANT,
        permission: PERMISSIONS.ACCESS,
        path: `${baseUrl}/sales-compliant/dashboard`,
      },
      {
        resource: RESOURCES.QUALITY_MONITORING,
        permission: PERMISSIONS.ACCESS,
        path: `${baseUrl}/quality-monitoring/dashboard`,
      },
    ];

    const firstAccessiblePage = accessiblePages.find(page =>
      hasPermission(page.resource, page.permission),
    );

    return firstAccessiblePage?.path ?? '/';
  };

  const handleSmartHome = () => {
    const smartPage = getSmartHomePage();
    navigate(smartPage);
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md text-center">
        <div className="mb-6">
          <div className="mx-auto flex size-16 items-center justify-center rounded-full bg-red-100">
            <span className="text-2xl text-red-600">🚫</span>
          </div>
        </div>

        <Heading1 className="mb-4 text-gray-900">Accès refusé</Heading1>

        <p className="mb-6 text-gray-600">
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
          Contactez votre administrateur si vous pensez qu'il s'agit d'une
          erreur.
        </p>

        <div className="space-y-3">
          <button
            onClick={handleSmartHome}
            className="w-full rounded-md bg-primary px-4 py-2 text-white transition-colors hover:bg-primary/90"
          >
            Aller à mes pages autorisées
          </button>

          <button
            onClick={() => navigate(-1)}
            className="w-full rounded-md border border-gray-300 bg-white px-4 py-2 text-gray-700 transition-colors hover:bg-gray-50"
          >
            Retour
          </button>
        </div>
      </div>
    </div>
  );
}
